import { geocoderGoogleAddressTypes } from '../geocoderAddressTypeContants';
import { BrandNameSearches } from '../constants';

/**
 * removes the country from the search suggestion (e.g., "London, UK" -> "London")
 * @param {string} suggestion
 * @returns string
 */
export const removeCountryFromSuggestion = suggestion => {
  const splits = suggestion.split(',');

  return splits.length > 1 ? splits.slice(0, -1).join(', ') : suggestion;
};

/**
 * Gets the
 * @param {address_components[]} addressComponents
 * @returns only the city and/or state of the entire address
 */
export const pluckCityState = addressComponents => {
  let locality = '';
  let stateOrSubstate = '';

  addressComponents.forEach(({ long_name, types }) => {
    const isLocalityOrSublocality =
      types.includes(geocoderGoogleAddressTypes.LOCALITY) ||
      types.includes(geocoderGoogleAddressTypes.SUBLOCALITY);

    if (locality === '' && isLocalityOrSublocality) {
      locality = long_name;
    }

    if (
      stateOrSubstate === '' &&
      types.includes(geocoderGoogleAddressTypes.ADMINISTRATIVE_AREA_L1)
    ) {
      stateOrSubstate = long_name;
    }
  });

  if (locality && stateOrSubstate) {
    return `${locality}, ${stateOrSubstate}`;
  }

  if (locality) {
    return locality;
  }

  if (stateOrSubstate) {
    return stateOrSubstate;
  }

  return '';
};

export const pluckBaiduCityState = addressComponents => {
  const { city, province } = addressComponents;

  if (city && province) {
    return `${city}, ${province}`;
  }

  if (city) {
    return city;
  }

  if (province) {
    return province;
  }

  return '';
};

export const pluckYandexCityState = addressComponents => {
  const components = addressComponents[0].GeoObject.metaDataProperty.GeocoderMetaData.Address.Components;
  
  const locality = components.find(comp => comp.kind === 'locality')?.name;
  const area = components.find(comp => comp.kind === 'area')?.name;

  if (locality && area) {
    return `${locality}, ${area}`;
  }

  if (locality) {
    return locality;
  }

  if (area) {
    return area;
  }

  return '';
};

export const formatYandexAddress = addressComponents => {
  const components = addressComponents[0].GeoObject.metaDataProperty.GeocoderMetaData.Address.Components;
  
  // Define the order of address parts we want to display
  const addressParts = ['locality', 'area', 'country']
    .map(kind => components.find(comp => comp.kind === kind)?.name)
    .filter(Boolean); // Remove undefined/null values

  return addressParts.join(', ');
};

/**
 * Brand name search matcher in the search auto complete
 * @param {string} inputBrandName
 * @returns string
 */
export const acsSuggestionByChainInputMatcher = inputBrandName => {
  const searchBrands = [
    BrandNameSearches.lenscrafters,
    BrandNameSearches.targetOptical,
    BrandNameSearches.pearleVision,
  ];
  let modifiedBrandName = null;

  const removedSpacesAndToLowerCaseString = str => {
    return str.toLowerCase().replace(' ', '');
  };

  searchBrands.map(brandName => {
    if (
      removedSpacesAndToLowerCaseString(inputBrandName).includes(
        removedSpacesAndToLowerCaseString(brandName)
      )
    ) {
      modifiedBrandName = brandName;
    }
  });

  return modifiedBrandName;
};
